var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" you must fill the OAuth client form "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.form()}}},[_vm._v(" go to OAuth client ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }